// @ts-nocheck
// export default Configuration
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  alpha,
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Select,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import LoadingOverlay from "../../components/Custom/LoadingOverlay";
import * as Yup from "yup";
import { useFormik } from "formik";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { CustomInput } from "../../components/Custom/Input";
import { CustomIconButton } from "../../components/Custom/CustomIconButton";
import { Delete } from "@mui/icons-material";
import {
  addContractorTypeLinkAction,
  deleteContractorLinkAction,
  getContractorLinkAction,
} from "../../store/actions/config/contractorLink";
import {
  contractorTypesFrontend,
  contractorTypesObj,
} from "../contractors/components/AddContractorForms/formSchemas/addContractorStep1Schema";
import DeletePink from "../../assets/images/Delete-pink.svg";
import { alertDialogAciton } from "../../store/actions/auth";

const ContractorLinks = () => {
  // constants
  const contractorTypes = useMemo(() => {
    return [
      {
        value: "1099",
        label: "1099",
      },
      {
        value: "V.C.",
        label: "V.C.",
      },
      {
        value: "w2",
        label: "W2",
      },
      // {
      //   value: "thirdParty",
      //   label: "Third Party",
      // },
      // {
      //   value: "outSource",
      //   label: "Outsourced",
      // },
    ];
  }, []);

  // const [isLoading, setIsLoading] = React.useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { isLoading, deleteLoading, links } = useSelector(
    (state) => state?.contractorLink,
  );
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const dispatch = useDispatch();

  const fetchLinks = useCallback(() => {
    dispatch(getContractorLinkAction({}));
  }, []);

  const initialValues = {
    links: [],
  };

  const validationSchema = Yup.object().shape({
    links: Yup.array().of(
      Yup.object().shape({
        contractorType: Yup.string()
          .oneOf(["1099", "V.C.", "w2", "thirdParty", "outsource"])
          .required("Contractor Type is required")
          .test(
            "unique-contractor-type",
            "This contractor type is already used",
            function (value) {
              if (!value) return true;

              const { path, parent, from } = this;
              const allLinks = from[1].value.links;

              // Count occurrences of this contractor type
              const occurrences = allLinks.filter(
                (link) => link.contractorType === value,
              ).length;

              return occurrences <= 1;
            },
          ),
        link: Yup.string()
          .url("Link must be of valid url.")
          .required("Link url is required."),
      }),
    ),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      // NOTE: do the add/update call to save the data.
      dispatch(
        addContractorTypeLinkAction({
          payload: {
            data: {
              linkData: values?.links,
            },
          },
          successCallback: () => {
            setIsEdit(false);
            fetchLinks();
          },
        }),
      );
    },
  });

  const {
    values,
    setValues,
    setFieldValue,
    errors,
    handleBlur,
    handleChange,
    submitForm,
  } = formik;

  const addNewClickHandler = () => {
    setValues((prev) => ({
      ...prev,
      links: [...prev.links, { contractorType: "", link: "" }],
    }));
  };

  // NOTE: to fetch the data when it's not available
  // UPDATE: don't fetch cause we're fetching it on app.jsx
  // useEffect(() => {
  //   if (links?.length == 0) {
  //     fetchLinks();
  //   }
  // }, [dispatch, links?.length, fetchLinks]);

  useEffect(() => {
    setFieldValue("links", links);
  }, [links, setFieldValue]);

  return (
    <>
      <Box
        sx={{
          padding: "20px 40px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          "@media (max-width: 600px)": {
            flexDirection: "column",
            padding: "20px 20px",
          },
        }}
      >
        <Typography
          variant={isSmallScreen ? "h3" : "h1"}
          sx={{
            "@media (max-width: 600px)": {
              marginBottom: "15px",
            },
          }}
        >
          Onboarding Links
        </Typography>

        <Button
          onClick={() => {
            setIsEdit((prev) => !prev);
          }}
        >
          {isEdit ? "View Links" : "Update Links"}
        </Button>
      </Box>
      <Box
        sx={{
          flex: "1",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {isLoading ? (
          <LoadingOverlay open={isLoading} />
        ) : (
          <Box
            sx={{
              flex: "1",
              padding: "0 1rem",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                flexDirection: "column",
                gap: "0.5rem",
                border: "1px solid #D175B6",
                borderRadius: "12px",
                boxShadow: "0px 10px 20px 0px rgba(0,0,0,0.5)",
                padding: "1rem",
                paddingY: "2.5rem",
                marginX: { md: "2rem", xs: "0.5rem" },
              }}
            >
              {isEdit ? (
                <>
                  {" "}
                  {/* NOTE: edit form setup*/}
                  {values?.links?.map((link, i) => (
                    <Grid container key={i}>
                      <Grid
                        xs={12}
                        md={4}
                        sx={{ px: { md: 1, xs: 0 }, py: { md: 0, xs: 1 } }}
                      >
                        <Select
                          fullWidth
                          value={link?.contractorType || ""}
                          displayEmpty
                          name={`links[${i}].contractorType`}
                          onBlur={handleBlur}
                          onChange={(e) =>
                            setFieldValue(
                              `links[${i}].contractorType`,
                              e?.target?.value,
                            )
                          }
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                overflowY: "auto",
                                "& ul": {
                                  overflowY: "auto",
                                },
                              },
                            },
                          }}
                          sx={{
                            color: getCssVariableHandler({
                              variableName: "--white-rgb",
                            }),
                            border: `1px solid ${getCssVariableHandler({ variableName: "--white-rgb" })}`,
                            borderRadius: "0.35rem",
                            height: "50px",
                            "& .MuiOutlinedInput-notchedOutline": {
                              border: "none",
                            },
                            "& .MuiSvgIcon-root": {
                              color: getCssVariableHandler({
                                variableName: "--white-rgb",
                              }),
                            },
                            "& ul": {
                              overflowY: "auto !important",
                            },
                          }}
                          renderValue={(selected) => {
                            if (!selected || selected === "") {
                              return (
                                <span
                                  style={{ color: "rgba(255, 255, 255, 0.5)" }}
                                >
                                  Contractor Type
                                </span>
                              );
                            }
                            // Find the label from contractorTypes
                            const type = contractorTypes.find(
                              (t) => t.value === selected,
                            );
                            return type?.label || selected;
                          }}
                        >
                          <MenuItem disabled value="" sx={{ display: "none" }}>
                            Contractor Type
                          </MenuItem>
                          {contractorTypes.map((type) => (
                            <MenuItem key={type.value} value={type.value}>
                              {type.label}
                            </MenuItem>
                          ))}
                        </Select>
                        {errors?.links?.[i]?.contractorType && (
                          <Typography color="error" variant="caption">
                            {errors.links[i].contractorType}
                          </Typography>
                        )}
                      </Grid>
                      <Grid xs={10} md={7} sx={{ px: { md: 1, xs: 0 } }}>
                        <CustomInput
                          fullWidth
                          placeholder="Onboarding link for contractor type"
                          name={`links[${i}].link`}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={link?.link || ""}
                        />
                        {errors?.links?.[i]?.link && (
                          <Typography color="error" variant="caption">
                            {errors.links[i].link}
                          </Typography>
                        )}
                      </Grid>
                      <Grid xs={1} md={1} sx={{ pl: 1 }}>
                        <Tooltip title={"Delete Link"}>
                          <Button
                            variant="text"
                            sx={{
                              backgroundColor: "#FFF",
                              padding: "8px 10px",
                              width: "auto",
                              minWidth: "auto",
                              mt: { xs: "0.25rem", sx: "0.25rem" },
                              borderRadius: "0.35rem",
                              "&:hover": {
                                backgroundColor: "#FFE5F5",
                              },
                            }}
                            onClick={() => {
                              const updatedLinks = values.links.filter(
                                (_, index) => index !== i,
                              );
                              setFieldValue("links", updatedLinks);
                            }}
                          >
                            <img src={DeletePink} />
                          </Button>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  ))}
                  <Box
                    className="bottom-btn-box"
                    sx={{
                      flexDirection: {
                        xs: "column !important",
                        sm: "column !important",
                        md: "row !important",
                      },
                    }}
                  >
                    <Button className="btn-pink" onClick={addNewClickHandler}>
                      add new link
                    </Button>
                    {/* NOTE: loader for add new link */}
                    <Button className="btn-pink" onClick={submitForm}>
                      Save
                    </Button>
                  </Box>
                </>
              ) : (
                <>
                  {/* NOTE: readonly view */}
                  {links?.length == 0 ? (
                    <Grid
                      container
                      sx={{
                        width: "100%",
                        // border: `1px solid ${alpha(getCssVariableHandler({ variableName: "--primary-pink-hex" }), 0.7)}`,
                        padding: "1rem",
                        borderRadius: "0.5rem",
                        alignItems: "center",
                        "&:hover": {
                          backgroundColor: "rgba(255, 255, 255, 0.03)",
                        },
                        transition: "background-color 0.2s ease",
                      }}
                    >
                      <Typography sx={{ textAlign: "center", width: "100%" }}>
                        No Onboarding Links Added
                      </Typography>
                    </Grid>
                  ) : null}
                  {links?.map((link, i) => {
                    return (
                      <Grid
                        container
                        key={i}
                        sx={{
                          width: "100%",
                          border: `1px solid ${alpha(getCssVariableHandler({ variableName: "--primary-pink-hex" }), 0.7)}`,
                          padding: "1rem",
                          borderRadius: "0.5rem",
                          alignItems: "center",
                          "&:hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.03)",
                          },
                          transition: "background-color 0.2s ease",
                        }}
                      >
                        {/* Contractor Type */}
                        <Grid xs={12} md={3}>
                          <Typography
                            sx={{
                              color: "#D175B6",
                              fontWeight: 600,
                              fontSize: "1rem",
                            }}
                          >
                            {contractorTypesFrontend?.[link?.contractorType] ||
                              link?.contractorType}
                          </Typography>
                        </Grid>

                        {/* Link */}
                        <Grid xs={10} md={8}>
                          <Typography
                            component="a"
                            href={link?.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              color: getCssVariableHandler({
                                variableName: "--white-rgb",
                              }),
                              fontSize: "1rem",
                              textDecoration: "none",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              overflowWrap: "anywhere",
                              "&:hover": {
                                color: "#D175B6",
                                textDecoration: "underline",
                              },
                            }}
                          >
                            {link?.link}
                          </Typography>
                        </Grid>

                        {/* Delete Button */}
                        <Grid
                          xs={2}
                          md={1}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Tooltip title="Delete Link">
                            <Button
                              variant="text"
                              sx={{
                                backgroundColor: "#FFF",
                                padding: "8px 10px",
                                width: "auto",
                                minWidth: "auto",
                                borderRadius: "0.35rem",
                                "&:hover": {
                                  backgroundColor: "#FFE5F5",
                                },
                              }}
                              onClick={() => {
                                dispatch(
                                  alertDialogAciton({
                                    open: true,
                                    title: "Warning",
                                    message:
                                      "Are you sure, you wish to delete this link?",
                                    onOk: () => {
                                      dispatch(
                                        deleteContractorLinkAction({
                                          payload: {
                                            params: {
                                              id: link?._id,
                                            },
                                          },
                                        }),
                                      );
                                    },
                                    okLabel: "Delete",
                                  }),
                                );
                              }}
                            >
                              {deleteLoading?.deleteId == link?._id ? (
                                <CircularProgress
                                  size={18}
                                  sx={{
                                    color: getCssVariableHandler({
                                      variableName: "--primary-pink-hex",
                                    }),
                                  }}
                                />
                              ) : (
                                <img
                                  src={DeletePink}
                                  alt="Delete"
                                  style={{ width: "18px", height: "18px" }}
                                />
                              )}
                            </Button>
                          </Tooltip>
                        </Grid>
                      </Grid>
                    );
                  })}
                </>
              )}
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

ContractorLinks.propTypes = {
  readOnly: PropTypes.bool,
};

export default ContractorLinks;